module.exports = __webpack_public_path__ + "img/plan_domaine_de_la_dourbie.3771c012.png";